import { useContext } from 'react';
import { useIntl as useReactIntl } from 'react-intl';
import { AppContext } from '../containers/App/context';

const useIntl = () => {
  const intl = useReactIntl();
  const appContext = useContext(AppContext) ?? {};

  return (
    intl ??
    appContext.intl ??
    (appContext.formatMessage
      ? { formatMessage: appContext.formatMessage }
      : undefined)
  );
};

export default useIntl;
